import React, { createContext, useContext } from "react";
import { db, messaging } from "../Config/Config";
import { doc, setDoc } from "firebase/firestore";
import { getToken } from "firebase/messaging";

const FCMcontext = createContext();
export const useMessage = () => useContext(FCMcontext);

const Message = ({ children }) => {


  const generateToken = async(uid) => {
      try {
      const token = await getToken(messaging, {
        vapidKey:
          "BBEh3Fd9l8GvA-BY46wXyfOLkMhj2lOgunXpCf-mmgiJpAZvmf1hnRNXymjAYWuUZoprsBFhhVpSAhJWSL-j9UE",
      });
      if (token) {
        await setDoc(doc(db, "token", uid), {
          token: token,
        });
      } else {
        console.error("Failed to get token.");
      }
    } catch (error) {
      console.error("Error getting token:", error);
    }
  };



  return (
    <FCMcontext.Provider value={{ generateToken }}>
      {children}
    </FCMcontext.Provider>
  );
};

export default Message;
